import { Vue, Component } from 'vue-property-decorator';


@Component({
    name: 'coverage',
})

export default class CoverageReport extends Vue {
    // ---------------------------------------------------------------------
    // Properties

    public getBackFlow() {
        this.$router.push('/dashboard');
    }
}
